






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { required } from 'vuelidate/lib/validators'
import flightStatusOptions from '@/store/data/flightStatusOptions'
import IDefaultQuasarComponentItem from '@/store/interface/IDefaultQuasarComponentItem'

@Component({
	name: 'FlightStatusPicker',
	validations: {
		modelData: {
			required
		}
	}
})
export default class FlightStatusPicker extends Vue {
	@Prop()
	private flightStatus!: string
	private flightStatusOptionsList: IDefaultQuasarComponentItem[] = flightStatusOptions
	private modelData: string | null = null
	private options: IDefaultQuasarComponentItem[] = this.flightStatusOptionsList || []

	beforeMount () {
		// Translating the day range options
		this.options = this.flightStatusOptionsList.map((el: IDefaultQuasarComponentItem) => {
			return {
				label: `${this.$t(el.label)}`,
				value: el.value
			}
		})
	}

	mounted () {
		// Pre-select flight status
		if (this.flightStatus) {
			this.modelData = this.flightStatus
		}
	}
}
